import React from 'react';
import moment from 'moment';
import UserContext from '../utils/getContext';
import { clearUserCache } from '../utils/memo';
import { SITE_URL, setLanguageForEmail } from '../utils/utils';
import { getRoute } from '../utils/router';
import { zendoStorage } from '../../hybrid/wrappers';
import SeoData from '../../widgets/seoData/SeoData';
import Alert from '../../widgets/alert/Alert';
import CookieModal from '../../widgets/cookieModal/CookieModal';
import Router from 'next/router';
import Language from './Language';
import Tooltips from './Tooltips';
import { getAltPageProps, getDomenData, processUrlParams } from './UserContext.helpers';

const UserContextComponent = (OriginalComponent) =>
    class WrapperComponent extends React.Component {
        constructor(params) {
            super(params);

            this.localStorageChangeHandler = this.localStorageChangeHandler.bind(this);

            this.changeData = this.changeData.bind(this);
            this.changeAlertSetter = this.changeAlertSetter.bind(this);
            this.onRouteChangeStart = this.onRouteChangeStart.bind(this);
            this.onRouteChangeDone = this.onRouteChangeDone.bind(this);
            this.newToken = this.newToken.bind(this);
            this.projectTime = this.projectTime.bind(this);

            const props = params?.pageProps;

            this.state = props?.file
                ? {}
                : {
                      activeLangs: props?.activeLangs,
                      settings: props?.settings,
                      seo: props?.seo,
                      currencies: props?.currencies,
                      captcha: props?.captcha,
                      menu: props?.menu,
                      lang: props?.lang || '',
                      offset: props?.offset,
                      userToken: false,
                      refer: props?.refer || false,
                      setAlert: () => true,
                      routerReLoader: false,
                      routerLoader: false,
                      storageLoaded: false,
                      showRegWindow: false,
                      localization: {},
                      marketingCurrency: props?.marketingCurrency,
                      loadedProfile: false,
                      //   країна відображення
                      display_country: '0'
                  };
        }

        localStorageChangeHandler(e) {
            if (!e.key) {
                this.setState((state) => ({
                    ...state,
                    userToken: zendoStorage.get('userToken') ? zendoStorage.get('userToken') : false,
                    refer: zendoStorage.get('refer') || false,
                    localization: zendoStorage.get('localization') ? JSON.parse(zendoStorage.get('localization')) : {},
                    display_country: zendoStorage.get('display_country') || false
                }));
            } else if (['userToken', 'refer'].includes(e.key)) {
                this.setState((state) => ({
                    ...state,
                    [e.key]: !!e.newValue ? e.newValue : false
                }));
            } else if (e.key === 'localization') {
                this.setState((state) => ({
                    ...state,
                    [e.key]: !!e.newValue ? JSON.parse(e.newValue) : {}
                }));
            }
        }

        async newToken(userToken, session) {
            clearUserCache();
            if (userToken) {
                zendoStorage.set('userToken', userToken, session);
            } else {
                zendoStorage.remove('userToken');
            }
            this.setState({ userToken });
        }
        async componentDidMount() {
            if (this.props.pageProps?.file || this.props.pageProps?.redirect) return;

            if (this.props.pageProps?.redirectTo) {
                this.props.router.replace(this.props.pageProps?.redirectTo?.destination);
            }

            const userToken = this.state.userToken || zendoStorage.get('userToken');

            if (userToken) {
                this.setState({ userToken, storageLoaded: true });
            } else {
                this.setState({ storageLoaded: true });
            }

            // країна відображення
            const display_country = !!Number(this.state.display_country)
                ? this.state.display_country
                : zendoStorage.get('display_country');
            if (display_country) {
                this.setState({ display_country });
            }

            await processUrlParams(this, userToken);
            const refer = this.state.refer || zendoStorage.get('refer') || false;

            refer && zendoStorage.set('refer', refer);
            !this.state.refer && this.setState({ refer });

            await processUrlParams(this, userToken, refer);
            await getAltPageProps(this, userToken);

            window.addEventListener('storage', this.localStorageChangeHandler);

            Router.router.events.on('routeChangeStart', this.onRouteChangeStart);
            Router.router.events.on('routeChangeComplete', this.onRouteChangeDone);
            Router.router.events.on('routeChangeError', this.onRouteChangeDone);
        }

        componentWillUnmount() {
            window.removeEventListener('storage', this.localStorageChangeHandler);
            Router.router.events.off('routeChangeStart', this.onRouteChangeStart);
            Router.router.events.off('routeChangeComplete', this.onRouteChangeDone);
            Router.router.events.off('routeChangeError', this.onRouteChangeDone);
        }

        changeAlertSetter(handler) {
            this.setState({ setAlert: handler });
        }
        onRouteChangeStart(url) {
            this.setState({ routerLoader: { from: Router.router.asPath, to: url } });
        }
        onRouteChangeDone() {
            window.scrollTo(0, 0);
            this.setState({ routerLoader: false });
        }
        projectTime() {
            return moment().add(this.state.offset);
        }
        async changeData(key, data) {
            this.setState({ [key]: data });
            if (key === 'lang') {
                this.setState({ routerReLoader: true });
                const oldLang = this.state.lang;
                const newLang = data;
                if (oldLang !== newLang) {
                    const defaultLang = this.state.activeLangs?.find((l) => l.isDefault);
                    if (defaultLang === newLang) {
                        this.props.router.push(getRoute(this.props.router.asPath));
                    }
                    const newRoute = getRoute(this.props.router.asPath);
                    this.props.router.push(`/${newLang}${newRoute === '/' ? '' : newRoute}`);
                }
                if (this.state.userToken) {
                    setLanguageForEmail(this.state.userToken, newLang);
                }
            } else if (key === 'localization') {
                zendoStorage.set('localization', JSON.stringify(data));
            }
        }

        render() {
            const params = getDomenData(`${SITE_URL}${this.props.router.asPath}`) || {};
            if (params?.id && params?.hash) return null;

            const { setAlert, seo, activeLangs, menu } = this.state;
            const { translates } = this.props.pageProps || {};

            let localization = this.state.localization;
            localization = typeof localization === 'string' ? JSON.parse(localization) : localization || {};
            const global = {
                ...this.state,
                activeLangs: activeLangs || [],
                menu: menu || {},
                time: this.projectTime,
                setUserToken: this.newToken,
                setAlertData: setAlert,
                setState: this.changeData,
                localization
            };
            const defaultSeo = (seo || [])?.find((s) => s.alias === 'default');

            return (
                <UserContext.Provider value={global}>
                    <Language page='all' translates={translates}>
                        <SeoData data={defaultSeo} />
                        <Tooltips>
                            <Alert changeAlertSetter={this.changeAlertSetter} />
                            <OriginalComponent {...this.props} />
                            <CookieModal />
                        </Tooltips>
                    </Language>
                </UserContext.Provider>
            );
        }
    };
export default UserContextComponent;
